import { useState } from "react"
import { useNavigate } from "react-router-dom"
import Navbar from "../components/Navbar"
import Pagination from "../components/Pagination"
import { usePortfolio } from "../hooks/useNFTs"

export default function Portfolio() {
  const [currentPage, setCurrentPage] = useState(1)
  const { data, isLoading, error } = usePortfolio(currentPage, 9)
  const navigate = useNavigate()

  const ownerships = data?.ownerships || []
  const pagination = data?.pagination

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 py-8">
      

        {error && (
          <div className="mb-4 p-4 bg-red-500/10 border border-red-500/30 text-red-400 rounded-lg">
            Failed to load portfolio. Please try again.
          </div>
        )}

        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <div className="text-lg text-text-secondary">Loading portfolio...</div>
          </div>
        ) : ownerships && ownerships.length > 0 ? (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {ownerships.map((ownership) => (
                <div key={ownership.id} className="bg-primary-light border border-secondary/30 rounded-lg shadow-lg shadow-secondary/10 overflow-hidden hover:shadow-cyan-glow-lg hover:border-secondary/60 transition-all">
                  <img
                    src={ownership.NFT.imageUrl || "/placeholder.svg"}
                    alt={ownership.NFT.name}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-4">
                    <h3 className="text-lg font-semibold text-text-primary mb-2">{ownership.NFT.name}</h3>
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-xl font-bold text-secondary">${ownership.NFT.price}</span>
                    </div>
                    <p className="text-xs text-text-secondary">
                      Purchased: {new Date(ownership.purchaseDate).toLocaleDateString()}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <Pagination pagination={pagination} onPageChange={handlePageChange} />
          </>
        ) : (
          <div className="text-center py-12">
            <p className="text-text-secondary text-lg mb-6">You don't own any NFTs yet.</p>
            <button
              onClick={() => navigate("/dashboard")}
              className="bg-secondary text-primary px-6 py-3 rounded-lg font-semibold hover:bg-secondary-light hover:shadow-cyan-glow transition-all"
            >
              Browse NFTs
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
